import cx from "classnames";
import { createContext, ReactNode } from "react";
import FlexLayoutItem, {
  layouts,
} from "@jnctn/design-system/Flexbox/FlexLayoutItem.component";
import styles from "./Menu.module.css";

export type Color = "white" | "black";

export const ColorContext = createContext<Color>("white");

const style = getComputedStyle(document.documentElement);
const sab = parseInt(style.getPropertyValue("--sab"));
export default function Menu({
  children,
  color = "white",
  shadow = true,
}: {
  children: ReactNode;
  className?: string;
  color?: Color;
  shadow?: boolean;
}) {
  return (
    <ColorContext.Provider value={color}>
      <FlexLayoutItem
        shrink={0}
        className={cx(styles.root, {
          [styles.shadow]: color === "white" && shadow,
        })}
        element={<aside style={{ height: `${sab + 80}px`, width: "auto" }} />}
      >
        <FlexLayoutItem
          layout={layouts.horizontalCenterAll}
          className="h-full max-w-4xl mx-auto"
        >
          {children}
        </FlexLayoutItem>
      </FlexLayoutItem>
    </ColorContext.Provider>
  );
}
